import { Redirect, Route, RouteProps } from "wouter";
import { useUser } from "../lib/user";

export default function PrivateRoute(props: RouteProps) {
  const { user } = useUser();

  if (typeof user === "undefined") {
    return <Redirect to="/login" />;
  }

  return <Route {...props} />;
}
